import React, {SyntheticEvent} from "react";
import {Avatar, Box, Container, Typography, useMediaQuery, useTheme} from "@mui/material";
import {Role} from "../../session_state";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import {useDispatch, useSelector} from "react-redux";
import Person from "@mui/icons-material/Person";
import {useNavigate} from "react-router-dom";
import {RootState} from "../../store";
import {userMenu} from "./menu";
import logo from "/assets/imgs/logo.png";
import {supabase} from "../../supabase";
import useDownloadImage from "../storage/useDownloadImage";

function hasRole(a: Array<Role>, b: Array<Role>): boolean {
    var setA = new Set(a);
    var setB = new Set(b);
    return Array.from(setA).filter(x => setB.has(x)).length > 0;
}

const UserAvatar = ({url}: { url: string }) => {

    const image = useDownloadImage("avatars", url)

    return image ? <Avatar
        alt="user avatar"
        src={image}
        sx={{
            width: 32,
            height: 32,
        }}
    /> : <Avatar><Person/></Avatar>
}

type MainLayoutProps = {}
const ResponsiveAppBar = ({}: MainLayoutProps) => {
    const [anchorElUser, setAnchorElUser] = React.useState<Element | null>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const myRoles = useSelector<RootState, Array<Role>>((state) => state.sessionState.user?.userRoles?.roles || [])
    const username = useSelector<RootState, string>((state) => state.sessionState.user?.email || "")
    const avatarUrl = useSelector<RootState, string>((state) => state.sessionState.user?.avatarUrl || "")
    const title = useSelector<RootState, string>((state) => state.nav.title)
    const handleOpenUserMenu = (event: SyntheticEvent) => {
        setAnchorElUser(event.currentTarget);
    };
    const theme = useTheme()
    const sm = useMediaQuery(theme.breakpoints.up('sm'));

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return <>
        <AppBar position="static">
            <Container maxWidth={false}>
                <Toolbar disableGutters>
                    <Box sx={{flexGrow: 0, display:"flex", gap:1}}>
                        <IconButton
                            size="large"
                            aria-label="main menu"
                            aria-controls="menu-appbar"
                            aria-haspopup="false"
                            href="/menu/main"
                        >
                            <MenuIcon sx={{color: "white"}}/>
                        </IconButton>
                        {sm && <IconButton
                            size="large"
                            aria-label="main menu"
                            aria-controls="menu-appbar"
                            aria-haspopup="false"
                            href="/reg"
                            sx={{padding:0}}
                        >
                            <img alt="logo"  style={{opacity: 0.7, marginBottom: "1px", width:"48px", height:"48px", minWidth:"48px"}}
                                 src={logo}/>
                        </IconButton>}
                    </Box>
                    <Typography
                        variant={"h6"}
                        id={"title"}
                        component={"div"}
                        sx={{flexGrow: 1, ml: 2, fontSize: "1em", textTransform: "uppercase", color: "white"}}
                    >
                        {title}
                    </Typography>
                    <Box sx={{flexGrow: 0}}>
                        <Tooltip title="Open settings">
                            <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                {avatarUrl ? <UserAvatar url={avatarUrl}/> : <Avatar><Person/></Avatar>}
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem disabled={true}>{username}</MenuItem>
                            {userMenu.filter(setting => hasRole(myRoles, setting.roles)).map((setting) => (
                                <MenuItem key={setting.name} onClick={() => {
                                    if ("action" in setting && setting.action) {
                                        dispatch(setting.action())
                                    }
                                    if ("route" in setting && setting.route) {
                                        navigate(setting.route);
                                    }
                                }}>
                                    <Typography textAlign="center">{setting.name}</Typography>
                                </MenuItem>
                            ))}
                            <MenuItem onClick={async () => {
                                await supabase.auth.signOut();
                                navigate("/");
                            }}>Odjava</MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>

    </>;
};
export default ResponsiveAppBar;


